import React, { useRef, useState, useEffect } from "react";
import { Button, Card, CardHeader, CardBody, Container, Row, Col } from "reactstrap";
import Header from "../../../../components/headers/Header";
import AuthorizedScreen from "../../../../components/base/AuthorizedScreen";
import * as Helper from "../../../../utils/Helper";
import { Actions, reducer, INITIAL_STATE, ActionTypes } from "../../../../redux/screens/admin/agent/useraccount/EditRedux";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import LoadingIndicator from "../../../../components/ui/LoadingIndicator";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { useForm } from "react-hook-form";

import { NavigationService, NavigateActionTypes } from "../../../../navigation";
import UIDs from "../../../../UIDs";
import "antd/dist/antd.css";

const uid = UIDs.screens.admin.agent.useraccount.edit;

class EditScreen extends AuthorizedScreen {
    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    get actionHandlers() {
        return {
            [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: { done: null, error: this._handleAsyncActionError },
            [ActionTypes.SAVE_USER_ACCOUNT_ASYNC]: { done: this._handleSaveUserAccountAsyncDone, error: this._handleAsyncActionError },
        };
    }

    localVars = {
        navParams: {},
    };

    constructor(props) {
        super(props);

        this.localVars.navParams = NavigationService.getNavParams(props);
    }

    componentDidMount() {
        super.componentDidMount();

        this.props.loadScreenViewAsync();
        this.props.getAllCountryCodeAsync();
    }

    render() {
        const { userAccount } = this.props.localState;
        return (
            <>
                {!userAccount || this.isActionExecuting(ActionTypes.LOAD_SCREEN_VIEW_ASYNC)
                    ? <LoadingIndicator />
                    : <EditForm
                        {...this.props}
                        userAccount={userAccount}
                        onSave={this._handleSaveInfo}
                        onBack={this._handleBack}
                        isDisabled={this.isActionExecuting(ActionTypes.SAVE_USER_ACCOUNT_ASYNC)}
                    />
                }
            </>
        );
    }

    _handleSaveInfo = (data) => {
        confirmAlert({
            title: this.props.t("confirmToActive"),
            message: this.props.t("sureToDo"),
            buttons: [
                {
                    label: this.props.t("yes"),
                    onClick: () => {
                        if(data.phone){
                            if(!data.countryCode || data.countryCode === "") data.countryCode = "86-CHN";
                            let code = data.countryCode;
                            data = { ...data, phone: code + "-" + data.phone,}
                        }
                        this.props.saveUserAccountAsync(data);
                    },
                },
                {
                    label: this.props.t("no"),
                },
            ],
        });
    };

    _handleBack = () => {
        NavigationService.navigateByAction(this, NavigateActionTypes.BACK);
    };

    _handleAsyncActionError = (action) => {
        this.displayError(action.error);
    };

    _handleSaveUserAccountAsyncDone = () => {
        const { addUserType, referralCodeAsTeacher, initialPassword, email } = this.props.localState;
        NavigationService.navigateToPage(this, `/admin/agent/useraccount/code`, { addUserType, referralCodeAsTeacher, initialPassword, email });
    };

}

function EditForm(props) {
    const { name, email, addUserType, isoCode, countryCode, nationality, phone, organization } = props.userAccount;
    const { countryCodeList } = props.localState;
    const { register, handleSubmit, errors, clearError } = useForm();
    const submitRef = useRef();

    return (
        <>
            <Header />
            <Container className="mt--7" fluid>
                <form onSubmit={handleSubmit(props.onSave)}>
                    <Row>
                        <Col>
                            <Card className="shadow">
                                <CardHeader className="bg-white border-0">
                                    <Row className="align-items-center">
                                        <Col xs="8">
                                            <h3 className="mb-0">{props.t("add")}</h3>
                                        </Col>
                                        <Col className="text-right" xs="4">
                                            <Button color="primary" disabled={props.isDisabled} onClick={() => submitRef.current.click()} size="sm">
                                                {props.t("activateNow")}
                                            </Button>
                                            <Button color="default" disabled={props.isDisabled} onClick={() => props.onBack()} size="sm">
                                                {props.t("back")}
                                            </Button>
                                        </Col>
                                    </Row>
                                </CardHeader>
                                <CardBody>
                                    <div className="pl-lg-4">
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label className="form-control-label">{props.t("nationality")}</label>
                                                    <select name="nationality" className="form-control-alternative form-control" defaultValue={nationality} ref={register()}>
                                                        {countryCodeList != null && countryCodeList.length > 0
                                                            ? countryCodeList.map((item, index) => (
                                                                <option key={index} value={item.countryCode} selected = {nationality === item.countryCode ? "selected" : ""}>
                                                                    {Helper.getCountryName(item.countryCode)}
                                                                </option>
                                                            ))
                                                            : null}
                                                    </select>
                                                    {errors.nationality && (
                                                        <div className="text-muted" style={{ marginTop: -20, marginBottom: 20 }}>
                                                            <small>
                                                                <span className="text-danger font-weight-700">{errors.nationality.message}</span>
                                                            </small>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label className="form-control-label">{props.t("organization")}</label>
                                                    <input name="organization" type="text" className="form-control-alternative form-control" defaultValue={organization}
                                                        ref={register({
                                                            required: props.t("fieldIsRequired"),
                                                            pattern: {
                                                                value: /[^\s]$/i,
                                                                message: props.t("organizationSpace")
                                                            },
                                                            validate: {
                                                                message: value => {
                                                                    if(Helper.existsSepcialContent(value)){
                                                                        return props.t("invalidContent");
                                                                    }
                                                                    return clearError();
                                                                }
                                                            }
                                                        })} />
                                                    {errors.organization && <span className="text-danger">{errors.organization.message}</span>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="pl-lg-4">
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label className="form-control-label">{props.t("email")}</label>
                                                    <input
                                                        className="form-control-alternative form-control"
                                                        name="email"
                                                        defaultValue={email}
                                                        type="email"
                                                        ref={register({
                                                            required: props.t("fieldIsRequired"),
                                                            pattern: {
                                                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                                                message: props.t("invalidEmailAddress"),
                                                            },
                                                            validate: {
                                                                message: value => {
                                                                    if (value.length > 50) {
                                                                        return props.t("invalidLength", { name: props.t("email"), max: 50 });
                                                                    }
                                                                    return clearError();
                                                                }
                                                            }
                                                        })}
                                                        maxLength={100}
                                                    />
                                                    {errors.email && <span className="text-danger">{errors.email.message}</span>}
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label className="form-control-label">{props.t("phone")}</label>
                                                    <input name="phone" type="text" className="form-control-alternative form-control" defaultValue={phone}
                                                        ref={register({
                                                            required: props.t("fieldIsRequired"),
                                                            pattern: {
                                                                value: /^[0-9-]{7,}$/,
                                                                message: props.t("invalidPhone"),
                                                            },
                                                            validate: {
                                                                message: value => {
                                                                    if (value.length > 20) {
                                                                        return props.t("invalidLength", { max: 20 });
                                                                    }else if(value.indexOf("--")!=-1){
                                                                        return props.t("invalidPhone");
                                                                    }else if(value.charAt(value.length -1) === "-"){
                                                                        return props.t("invalidPhone");
                                                                    }else if(value.charAt(0) === "-"){
                                                                        return props.t("invalidPhone");
                                                                    }
                                                                    return clearError();
                                                                }
                                                            }
                                                        })} />
                                                    {errors.phone && <span className="text-danger">{errors.phone.message}</span>}
                                                    {/*<div className="row">
                                                        <div className="col-lg-5">
                                                            <select name="countryCode" className="form-control-alternative form-control" defaultValue={isoCode + "-" + countryCode} ref={register()}>
                                                                {countryCodeList != null && countryCodeList.length > 0
                                                                    ? countryCodeList.map((item, index) => (
                                                                        <option key={index} value={item.isoCode + "-" + item.countryCode} selected = {isoCode + "-" + countryCode === item.isoCode + "-" + item.countryCode ? "selected" : ""}>
                                                                            {Helper.getCountryName(item.countryCode)}+({item.isoCode})
                                                                        </option>
                                                                    ))
                                                                    : null}
                                                            </select>
                                                            {errors.countryCode && (
                                                                <div className="text-muted" style={{ marginTop: -20, marginBottom: 20 }}>
                                                                    <small>
                                                                        <span className="text-danger font-weight-700">{errors.countryCode.message}</span>
                                                                    </small>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className="col-lg-7">
                                                        </div>
                                                    </div>*/}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="pl-lg-4">
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label className="form-control-label">{props.t("name")}</label>
                                                    <input
                                                        className="form-control-alternative form-control"
                                                        name="name"
                                                        defaultValue={name}
                                                        type="text"
                                                        ref={register({
                                                            required: props.t("fieldIsRequired"),
                                                            validate: {
                                                                message: value => {
                                                                    if (value.replace(/\s/g, "").length === 0) {
                                                                        return props.t("nameSpace");
                                                                    }
                                                                    if (value.length > 20) {
                                                                        return props.t("invalidLengthH", { name: props.t("name"), max: 20 });
                                                                    }
                                                                    return clearError();
                                                                }
                                                            }
                                                        })}
                                                        maxLength={100}
                                                    />
                                                    {errors.name && <span className="text-danger">{errors.name.message}</span>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/*<div className="pl-lg-4">
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label className="form-control-label">{props.t("role")}</label>
                                                    <select
                                                        className="form-control-alternative form-control"
                                                        name="addUserType"
                                                        defaultValue={addUserType || 0}
                                                        ref={register({
                                                            required: props.t("fieldIsRequired")
                                                        })}>
                                                            <option value={0}>{props.t("student")}</option>
                                                            <option value={1}>{props.t("teacher")}</option>
                                                            {/*<option value={2}>{props.t("studentAndTeacher")}</option>*/}
                                                    {/*</select>
                                                    {errors.addUserType && <span className="text-danger">{errors.addUserType.message}</span>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>*/}
                                    <input
                                        className="form-control-alternative form-control"
                                        name="addUserType"
                                        value={1}
                                        type="hidden"
                                        ref={register}
                                        maxLength={100}
                                    />
                                    <input ref={submitRef} type="submit" hidden />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </form>
            </Container>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId,
        partnerId: state.session.partner ? state.session.partner.id : null,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadScreenViewAsync: (vo) => dispatch(Actions.loadScreenViewAsync(vo)),
        saveUserAccountAsync: (vo) => dispatch(Actions.saveUserAccountAsync(vo)),
        getAllCountryCodeAsync: () => dispatch(Actions.getAllCountryCodeAsync()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(uid)(EditScreen));
